export default {
  fields: {
    sales: {
      label: 'Vendas',
    },
    gift_cards_sales: {
      label: 'Vendas de Gift Cards',
    },
    average_order_value: {
      label: 'Valor Médio de Pedido',
    },
    savings: {
      label: 'Poupança em taxas de terceiros',
    },
    reservations: {
      label: 'Reservas',
    },
    sales_from_email: {
      label: 'Vendas por Email',
    },
    sales_from_google_seo: {
      label: 'Vendas por Google SEO',
    },
    sales_from_google_business_profile: {
      label: 'Vendas por Google Business',
    },
    sales_from_google_ads: {
      label: 'Vendas por Google Ads',
    },
    sales_from_flyers: {
      label: 'Vendas por Flyers',
    },
    sales_from_social_media: {
      label: 'Vendas por Redes Sociais',
    },
    sales_from_facebook_ads: {
      label: 'Vendas por Facebook Ads',
    },
    tips: {
      label: 'Gorjetas',
    },
    new_customers: {
      label: 'Novos Clientes',
    },
    returning_customers: {
      label: 'Clientes Recorrentes',
    },
    new_visitors: {
      label: 'Novos Visitantes',
    },
    new_followers: {
      label: 'Novos Seguidores',
    },
    total_followers: {
      label: 'Total de Seguidores',
    },
    delivered_messages: {
      label: 'Mensagens Entregues',
    },
    average_open_rate: {
      label: 'Taxa Média de Abertura de Email',
    },
    average_click_rate: {
      label: 'Taxa Média de Cliques',
    },
    website_visitors_from_email: {
      label: 'Visitantes do Site por Email',
    },
    sales_from_google_business: {
      label: 'Vendas por Google Business',
    },
    total_reservations: {
      label: 'Reservas',
    },
    website_visitors_from_google_seo: {
      label: 'Cliques no Site por Google SEO',
    },
    website_clicks_from_google_business: {
      label: 'Cliques no Site por Google Business',
    },
    website_visitors_from_google_ads: {
      label: 'Cliques no Site por Google Ads',
    },
    website_visitors_from_social_media: {
      label: 'Cliques no Site por Redes Sociais',
    },
    calls_from_google_ads: {
      label: 'Chamadas por Google Ads',
    },
    directions_from_google_ads: {
      label: 'Direções por Google Ads',
    },
    google_seo_orders_count: {
      label: 'Google SEO',
    },
    google_business_orders_count: {
      label: 'Google Business',
    },
    google_ads_orders_count: {
      label: 'Google Ads',
    },
    facebook_ads_orders_count: {
      label: 'Facebook Ads',
    },
    social_media_orders_count: {
      label: 'Redes Sociais',
    },
    flyer_orders_count: {
      label: 'Flyers',
    },
    email_orders_count: {
      label: 'Emails',
    },
    other_orders_count: {
      label: 'Outros',
    },
    gmv: {
      label: 'GMV',
    },
    gift_cards_gmv: {
      label: 'Gift Cards',
    },
    net_billed_revenue: {
      label: 'Receita Faturada (Líquido)',
    },
    net_billed_revenue_subscription: {
      label: 'Receita de subscrição faturada',
    },
    net_billed_revenue_service_fee: {
      label: 'Receita de taxa de serviço faturada',
    },
    net_billed_revenue_external_delivery_platform_fee: {
      label: 'Receita de taxa de entrega faturada',
    },
    net_billed_revenue_other: {
      label: 'Receita de encargos de serviço faturados',
    },
    net_billed_revenue_external_delivery_passthrough_fee: {
      label: 'Entrega Faturada - Repasse',
    },
    net_billed_revenue_platform_processing_fee: {
      label: 'Receita de taxa de processamento da plataforma faturada',
    },
    gross_cash_income: {
      label: 'Receita em dinheiro (Bruta)',
    },
    gross_cash_income_subscription: {
      label: 'Receita em dinheiro de subscrições',
    },
    gross_cash_income_service_fee: {
      label: 'Receita em dinheiro de taxas de serviço',
    },
    gross_cash_income_external_delivery_platform_fee: {
      label: 'Receita em dinheiro de taxas de entrega',
    },
    gross_cash_income_other: {
      label: 'Receita em dinheiro de encargos de serviço',
    },
    gross_cash_income_external_delivery_passthrough_fee: {
      label: 'Receita em dinheiro de taxas de repasse de entrega',
    },
    gross_cash_income_platform_processing_fee: {
      label: 'Receita em dinheiro de taxas de processamento da plataforma',
    },
    net_cash_income: {
      label: 'Receita em dinheiro (Líquida)',
    },
    net_cash_income_subscription: {
      label: 'Receita em dinheiro de subscrições',
    },
    net_cash_income_service_fee: {
      label: 'Receita em dinheiro de taxas de serviço',
    },
    net_cash_income_external_delivery_platform_fee: {
      label: 'Receita em dinheiro de taxas de entrega',
    },
    net_cash_income_other: {
      label: 'Receita em dinheiro de encargos de serviço',
    },
    net_cash_income_external_delivery_passthrough_fee: {
      label: 'Receita em dinheiro de taxas de repasse de entrega',
    },
    net_cash_income_platform_processing_fee: {
      label: 'Receita em dinheiro de taxas de processamento da plataforma',
    },
    manual_connect_transfers: {
      label: 'Reembolsado a restaurantes',
    },
    processing_fees: {
      label: 'Taxas de Processamento',
    },
    processing_fees_stripe: {
      label: 'Taxas de Processamento (Stripe)',
    },
    processing_fees_paypal: {
      label: 'Taxas de Processamento (PayPal)',
    },
    rejected_orders: {
      label: 'Encomendas Rejeitadas',
    },
    rejected_orders_amount: {
      label: 'Valor de Encomendas Rejeitadas',
    },
    rejected_orders_count: {
      label: 'Número de Encomendas Rejeitadas',
    },
    rejected_orders_rate: {
      label: 'Taxa de Encomendas Rejeitadas',
    },
    rejected_orders_rate_breakdown: {
      label: 'Distribuição da Taxa de Encomendas Rejeitadas',
    },
    orders: {
      label: 'Encomendas',
    },
    total_orders: {
      label: 'Total de Encomendas',
    },
    pickup_orders_rate: {
      label: 'Taxa de Encomendas para Levantamento',
    },
    delivery_orders_rate: {
      label: 'Taxa de Encomendas para Entrega',
    },
    other_orders_rate: {
      label: 'Taxa de Outras Encomendas',
    },
    customers: {
      label: 'Total de Clientes',
    },
    customers_auth_state: {
      label: 'Estado de Autenticação do Cliente',
    },
    website_reservations: {
      label: 'Reservas pelo Website',
    },
    google_reservations: {
      label: 'Reservas pelo Google',
    },
    companies: {
      label: 'Empresas',
    },
    live_companies: {
      label: 'Restaurantes Ativos',
    },
    live_companies_percentage: {
      label: 'Percentagem de Restaurantes Ativos',
    },
    setup_packages_breakdown: {
      label: 'Pacotes de configuração',
    },
    setup_packages_billing_mode_breakdown: {
      label: 'Pacotes de configuração por fonte de faturação',
    },
    crossed_sales_level_this_month: {
      label: 'Nível de Vendas Atingido Este Mês',
    },
    crossed_sales_level_total: {
      label: 'Total de Níveis de Vendas Atingidos',
    },
    crossed_sales_level_percentage: {
      label: 'Percentagem de Nível de Vendas Atingido',
    },
    has_delivery: {
      label: 'Entrega Própria',
    },
    has_only_pickup: {
      label: 'Apenas Levantamento',
    },
    has_storefront: {
      label: 'Tem Loja Online',
    },
    has_storefront_percentage: {
      label: 'Percentagem de Loja Online',
    },
    use_external_delivery: {
      label: 'Entrega Externa',
    },
    crossed_sales: {
      label: 'Ultrapassou {{value}} vendas',
    },
    restaurant_partners: {
      label: 'Restaurantes Parceiros',
    },
    registered_restaurants: {
      label: 'Restaurantes Registados',
    },
    signed_restaurants: {
      label: 'Restaurantes com Contrato',
    },
    use_reservations: {
      label: 'Utilizam Reservas',
    },
    number: {
      label: 'Número',
    },
    restaurants_percentage: {
      label: 'Percentagem de Restaurantes',
    },
    crossed_sales_level: {
      label: 'Nível de Vendas Atingido',
    },
    order_method: {
      label: 'Método de Encomenda',
    },
    own_delivery: {
      label: 'Entrega Própria',
    },
    only_pickup: {
      label: 'Apenas Levantamento',
    },
    storefront: {
      label: 'Loja Online',
    },
    sales_tiers: {
      label: 'Níveis de Vendas',
    },
    new_pricing_adoption_rate: {
      label: 'Taxa de adoção do novo preçário',
    },
    mobile_app_attach_rate: {
      label: 'Taxa de adesão à app móvel',
    },
    mobile_app_setup_fee_breakdown: {
      label: 'Taxas de configuração da app móvel escolhidas',
    },
    first_delivery: {
      label: 'Uber (Primeira Entrega)',
    },
    wolt_drive: {
      label: 'Wolt',
    },
    uber_drive: {
      label: 'Uber',
    },
    delivery_quotes_count: {
      label: 'Número de Cotações de Entrega',
    },
    deliveries_count: {
      label: 'Número de Entregas',
    },
    delivery_conversion: {
      label: 'Taxa de Conversão de Entrega',
    },
    delivery_quotes_provider_breakdown: {
      label: 'Cotações de Entrega por Fornecedor',
    },
    deliveries_provider_breakdown: {
      label: 'Entregas por Fornecedor',
    },
    delivery_distance_breakdown: {
      label: 'Distribuição por Distância de Entrega',
    },
    total_delivered: {
      label: 'Mensagens Entregues',
    },
    website_visitors_from_google_business_profile: {
      label: 'Cliques no website via Google Business',
    },
    google_business_impressions: {
      label: 'Impressões via Google Business',
    },
    google_business_website_clicks: {
      label: 'Cliques no website via Google Business',
    },
    google_ads_impressions: {
      label: 'Impressões Google Ads',
    },
    google_ads_clicks: {
      label: 'Cliques Google Ads',
    },
    google_ads_phone_calls: {
      label: 'Chamadas Google Ads',
    },
    google_ads_directions: {
      label: 'Direções Google Ads',
    },
    google_ads_absolute_top_impression_percentage: {
      label: '% Média de Impressão no Topo Absoluto Google Ads',
    },
    google_ads_average_cpc: {
      label: 'Custo Médio por Clique Google Ads',
    },
    google_ads_conversions_from_interactions_rate: {
      label: 'Taxa Média de Conversões por Interação Google Ads',
    },
    website_visits: {
      label: 'Visitas ao Website',
    },
    website_visitors: {
      label: 'Visitantes do Website',
    },
    companies_with_activated_reservations: {
      label: 'Restaurantes com reservas ativadas',
    },
    online_orders_count: {
      label: 'Encomendas Online',
    },
    cash_orders_count: {
      label: 'Encomendas Online',
    },
    cash_sales: {
      label: 'Vendas em Dinheiro',
    },
    online_sales: {
      label: 'Vendas Online',
    },
    payouts: {
      label: 'Pagamentos',
    },
    last_payout_amount: {
      label: 'Último pagamento',
    },
    pending_payout_amount: {
      label: 'Em trânsito',
    },
    future_payout_amount: {
      label: 'Disponível para pagamentos futuros',
    },
    mobile_app_average_order_value: {
      label: 'VME via App',
    },
    mobile_app_gmv: {
      label: 'Total de Vendas via App',
    },
    mobile_app_gmv_percentage: {
      label: '% de Receita via App',
    },
    mobile_app_downloads: {
      label: 'Total de Transferências da App',
    },
    mobile_app_orders_count: {
      label: 'Total de Encomendas via App',
    },
    net_billed_revenue_gift_cards: {
      label: 'Receita de cartões oferta faturados',
    },
    gross_cash_income_gift_cards: {
      label: 'Receita em dinheiro de cartões oferta',
    },
    net_cash_income_gift_cards: {
      label: 'Receita em dinheiro de cartões oferta',
    },
    platform_processing_fees: {
      label: 'Taxas de Processamento da Plataforma',
    },
  },
};
